<mat-card>{{'sharedprojects.title' | translate}}</mat-card>

<div fxLayout="row wrap" fxLayoutGap="32px" fxLayoutAlign="flex-start">
    <mat-card *ngFor="let project of projects" class="card-project">
        <mat-card-title>{{project.name}} ({{ project.type}})</mat-card-title>
        <mat-card-content>
            <p>{{project.description}}</p>
            <p>{{'sharedprojects.author' | translate}}: {{ project.username }}</p>
            <p>{{'sharedprojects.reinventions' | translate}}: {{ project.reinventions }}</p>
            <h4>{{'sharedprojects.classes' | translate}}</h4>
            <mat-chip-list>
                <mat-chip color="primary" *ngFor="let clase of project.classes"> {{clase}}</mat-chip>
            </mat-chip-list>
        </mat-card-content>
        <mat-card-actions>
            <button mat-raised-button (click)="loadProject(project)" mat-button>
                <mat-icon>input</mat-icon> {{'sharedprojects.load' | translate}}
            </button>
            <button mat-raised-button (click)="reinventProject(project)" mat-button>
                <mat-icon>repeat</mat-icon> {{'sharedprojects.reinvent' | translate}}
            </button>
            <!-- <button (click)="likeProject(project)" mat-button>
                    <mat-icon>thumb_up</mat-icon> {{project.likes}}
                </button> -->
        </mat-card-actions>
    </mat-card>
</div>